import {styled} from '@linaria/react';
import React, {forwardRef} from 'react';
import {COLORS} from '../../../constants/colors';
import {Icon} from '../Icon/Icon';
import {GenericIconName} from '../Icon/IconName';

interface RingProps {
  $color?: string;
  $size: string;
}

export const LoadingSpinner = forwardRef<
  HTMLDivElement,
  {
    color?: string;
    size?: string;
    className?: string;
    style?: React.CSSProperties;
  }
>(function LoadingSpinner({color, size = '24px', className, style}, ref) {
  return (
    <Container className={className} style={style} ref={ref}>
      <StyledIcon asset={GenericIconName.Spinner} $size={size} $color={color} />
    </Container>
  );
});

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const StyledIcon = styled(Icon)<RingProps>`
  display: inline-block;
  position: relative;
  width: ${({$size}) => $size};
  height: ${({$size}) => $size};

  animation: spin 900ms linear infinite;
  border-color: ${({$color}) => $color || COLORS.Black} transparent transparent
    transparent;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
